module.exports = __webpack_public_path__ + "img/master-project-idle.4b340bad.png";